<script>
import { mapGetters } from 'vuex'
import { PermissionScope } from '@/shared/constants/permissions/PermissionScope'
import { PermissionModifier } from '@/shared/constants/permissions/PermissionModifier'

export default {
  name: 'BookingListTab',
  props: {
    approvalCount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      activeTab: 'upcoming',
    }
  },
  computed: {
    ...mapGetters({
      hasPermissionRegardlessOfLevel: 'auth/hasPermissionRegardlessOfLevel',
    }),
    showApprovalTab() {
      return (
        this.hasPermissionRegardlessOfLevel(
          PermissionScope.BOOKING,
          PermissionModifier.CREATE
        ) ||
        this.hasPermissionRegardlessOfLevel(
          PermissionScope.PENDING_BOOKING,
          PermissionModifier.CREATE
        )
      )
    },
    tabs() {
      const baseTabs = [
        { name: 'upcoming', label: this.$t('bookingListTabs.upcoming') },
        { name: 'past', label: this.$t('bookingListTabs.past') },
        { name: 'cancelled', label: this.$t('bookingListTabs.cancelled') },
        { name: 'all', label: this.$t('bookingListTabs.all') },
      ]

      if (this.showApprovalTab) {
        baseTabs.push({
          name: 'ApprovalRequired',
          label: this.$t('bookingListTabs.approvalRequired'),
        })
      }

      return baseTabs
    },
  },
  methods: {
    setActiveTab(tabName) {
      this.activeTab = tabName
      this.$emit('set-tab', tabName)
    },
  },
}
</script>

<template>
  <div class="tab-bar">
    <div
      v-for="(tab, index) in tabs"
      :key="`tab-${index}`"
      :class="['tab', { active: activeTab === tab.name }]"
      :data-tab="`tab_${tab.name}`"
      @click="setActiveTab(tab.name)"
    >
      <span>{{ tab.label }}</span>

      <!-- Red dot only on Approval Required -->
      <v-badge
        v-if="tab.name === 'ApprovalRequired' && Number(approvalCount) > 0"
        color="badge-error"
        :content="approvalCount.toString()"
        class="notification-dot"
      >
      </v-badge>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-tab.scss';
</style>
